export const RPC_SERVER = 'https://proxy.nanos.cc/proxy'
export const RPC_SWEEP_SERVER = 'https://proxy.nanos.cc/proxy'
export const RPC_LIMIT = 'You have done too many RPC requests. Try again in an hour.'
export const RPC_CREDS = 'rpc:pLj8mgvejDGpgtXqFsKJ'